// Shared uniform objects for the retro/dither post pass — one set per scene.
// The SAME object instances are handed to the post material (ViewPostProcessing
// merges them into material.uniforms) AND written by the dev leva panel
// (Utils/PostFxLevaPanel.tsx) — so tuning is live with zero re-renders. In
// production these are just the shipped values.
//
// Disable a scene's pass by setting its uDither AND uPixelRes to 0 — the GLSL
// (RetroDither in Materials/Common.tsx) early-outs on both.
const fxSet = (dither: number, levels: number, pixelRes: number) => ({
  uDither: { value: dither }, // posterize+dither mix (0 = off)
  uLevels: { value: levels }, // colour levels per channel
  uPixelRes: { value: pixelRes }, // virtual VERTICAL resolution (e.g. 360); 0 = off
  // Music-equalizer brightness pump (musicEnergy.ts) — written per frame by
  // the owning scene's useFrame; shaders that don't declare it ignore it.
  uMusicPulse: { value: 0 },
});

export type PostFxSet = ReturnType<typeof fxSet>;

// Render-fps cap for the shared canvas (driven by FrameDriver in Scene.tsx).
// 120Hz ProMotion doubles all GPU work for ambient content — ship 60. Dev
// knob lives in PostFxLevaPanel.
export const FRAME_CAP = { value: 60 };

// Set while the SCRUM Nebula easter egg covers the site: FrameDriver stops
// advancing the shared canvas (the game runs its own Canvas2D loop).
export const PAUSE_3D = { value: false };

export const POST_FX = fxSet(0.29, 3.0, 0.0); // ClientBanner (shipped look)
export const POST_FX_VISUAL = fxSet(0.45, 8.0, 0.0);
export const POST_FX_STARFIELD = fxSet(0.32, 4.0, 720.0);
export const POST_FX_FOOTER = fxSet(0.3, 32.0, 480.0);
export const POST_FX_FOOTER_PLANET = fxSet(0.7, 32.0, 360.0);

// Route-transition fade for the scenes that opt in via ViewPostProcessing's
// `transitionFade` (Visual, ClientBanner): MainCanvas animates this on stage
// changes; the quads multiply it in display space and skip their FBO passes
// at 0. The ambient StarField view doesn't opt in, and the canvas itself no
// longer fades — the sky stays steady while the content scenes hide under
// the Stars.tsx warp overlay.
export const SCENE_TRANSITION = {
  fade: { value: 1 },
};
